import rwdImageMaps from '../../plugins/jquery.rwdImageMaps.js';

$(function() {
  $('img[usemap]').rwdImageMaps();
});